import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'habit-ui', {
    goToToday: 'Go to today',
    createTaskTitle: 'Create a task',
    createTaskDescription: 'Create a task—a one-off event on a given day.',
    startHabitTitle: 'Start a habit',
    startHabitDescription: 'Start a habit—a recurring task.',
    editHabit: 'Edit habit',
    trashTask: 'Trash task',
    selectDay: 'Select day',
    showToolInvocations: 'Show tool invocations',
    dayView: 'Day view',
    weekView: 'Week view',
    monthView: 'Month view',
    timeView: 'Time view',
    trashHabit: 'Trash habit',
    tasksSelected: '{{count}} tasks selected',
    autoCompleteSection: 'Auto-complete from metric',
    autoCompleteMetricLabel: 'Metric',
    autoCompleteEmptyState:
      'Link a tracked metric to auto-check this habit when your data crosses a threshold.',
    autoCompleteDirectionHigher: 'Completes when the day value is at least your thresholds.',
    autoCompleteDirectionLower:
      'Stay-under habit: confirms at day close when the day value is under your thresholds.',
    effortTrivial: 'Trivial',
    effortEasy: 'Easy',
    effortMedium: 'Medium',
    effortHard: 'Hard',
    complianceSevenDay: '7-day compliance',
    complianceTrend: 'Compliance trend',
    complianceHistory: 'Compliance history',
    taskCreated: 'New task created',
    habitCreated: 'New habit created',
    eventMoved: 'Event moved',
    eventMovedToTrash: 'Event moved to the trash',
    habitMovedToTrash: 'Habit moved to the trash',
    tasksMovedToTrash: '{{count}} tasks moved to the trash',
    habitRestoreRefused: 'Could not restore the habit',
    eventRestoreRefused: 'Could not restore the event',
    tasksRestoreRefused: '{{count}} of {{total}} tasks could not be restored',
  });
}
